import React from 'react';
import { Box, Grid , Typography} from '@mui/material';
const TaxBillColAndPayInfo = ({ taxbill }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        mt: 1,

      }}
    >
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
        spacing={1}
        sx={{ py: 1, borderBottom: 1, borderColor: 'divider', }}
      >
        <Grid item xs={2}><Typography variant="subtitle2" component="div">지급종류</Typography></Grid>
        <Grid item xs={2}><Typography variant="body2" component="div">{taxbill?.procTyp}</Typography></Grid>
        <Grid item xs={2}><Typography variant="subtitle2" component="div">수금(지급)예정일</Typography></Grid>
        <Grid item xs={2}><Typography variant="body2" component="div">{taxbill?.procPlanDt}</Typography></Grid>
        <Grid item xs={2}><Typography variant="subtitle2" component="div">수금(지급)요청 여부</Typography></Grid>
        <Grid item xs={2}><Typography variant="body2" component="div">{taxbill?.procPlanYn}</Typography></Grid>
      </Grid>
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
        spacing={1}
        sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
      >
        <Grid item xs={2}><Typography variant="subtitle2" component="div">수금(지급)일</Typography></Grid>
        <Grid item xs={2}><Typography variant="body2" component="div">{taxbill?.procCompDt}</Typography></Grid>
        <Grid item xs={2}><Typography variant="subtitle2" component="div">수금(지급) 완료여부</Typography></Grid>
        <Grid item xs={2}><Typography variant="body2" component="div">{taxbill?.procCompYn}</Typography></Grid>
        <Grid item xs={2}></Grid>
        <Grid item xs={2}></Grid>
      </Grid>
    </Box>
  );
};

export default TaxBillColAndPayInfo;
